document.addEventListener(
  'DOMContentLoaded',
  function () {
    $('product-block').each(function () {
      const collectionHandle = $(this).data('collection-handle');
      const templateName = $(this).data('template');
      if (
        templateName == 'collection' &&
        collectionHandle == 'personalization'
      )
        $(this)
          .find('.personalization-card-button')
          .removeClass('hidden');
      else $(this).find('.quick-action-button').removeClass('hidden');
    });

    $(function () {
      $(document).on(
        'click',
        '.product-block-options__item',
        async function (e) {
          e.preventDefault();
          const $productBlock = $(this).closest('product-block');
          const variant_url = $(this).data('variant-url');
          const collectionHandle = $productBlock.data(
            'collection-handle'
          );
          let urlSuffix = '';
          if (collectionHandle == 'personalization') {
            urlSuffix = `-pz`;
          }
          const templateName = $productBlock.data('template');
          const bundleBlock = $productBlock.data('bundle');
          const url = bundleBlock
            ? `${variant_url}&section_id=product-block-bundle${urlSuffix}`
            : `${variant_url}&section_id=product-block${urlSuffix}`;
          const response = await fetch(url, {
            credentials: 'same-origin',
            method: 'GET',
          });
          const responseText = await response.text();
          const responseHTML = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );
          const productBlock =
            responseHTML.querySelector('.block-inner');
          $productBlock.html(productBlock);
          // Correct button show logic:
          if (
            templateName == 'collection' &&
            collectionHandle == 'personalization'
          ) {
            $productBlock
              .find('.personalization-card-button')
              .removeClass('hidden');
          } else {
            $productBlock
              .find('.quick-action-button')
              .removeClass('hidden');
          }
        }
      );

      $(document).on(
        'click',
        '.option-selector--swatch .opt-label',
        async function (e) {
          if ($(this).hasClass('swatch-toggle-label')) return;
          e.preventDefault();
          const variantId = $(this).prev().data('variant-id');
          console.log($(this).closest('.quickbuy-modal').length);
          if ($(this).closest('.quickbuy-modal').length) {
            const url = $(this).prev().data('product-url');
            document.dispatchEvent(
              new CustomEvent('quick-view:variant-changed', {
                detail: {
                  productUrl: url,
                  qbId: `Quickbuy-${variantId}`,
                },
              })
            );
            return;
          }
          const originalSection = $('.section-main-product');

          const sectionId = originalSection
            .attr('id')
            .replace('shopify-section-', '');
          const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
          const response = await fetch(url, {
            credentials: 'same-origin',
            method: 'GET',
          });
          const responseText = await response.text();
          const responseHTML = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );
          const productElement = responseHTML.querySelector(
            '.section-main-product'
          );
          if (productElement) {
            window.history.replaceState(
              {},
              '',
              `${window.location.pathname}?variant=${variantId}`
            );
            originalSection.html(productElement.innerHTML);
            document.dispatchEvent(
              new CustomEvent('variant-changed')
            );
          }
        }
      );
    });
  },
  false
);
